/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var KubeResourceType;
    (function (KubeResourceType) {
        KubeResourceType[KubeResourceType["Pods"] = 1] = "Pods";
        KubeResourceType[KubeResourceType["Deployments"] = 2] = "Deployments";
        KubeResourceType[KubeResourceType["Services"] = 4] = "Services";
        KubeResourceType[KubeResourceType["ReplicaSets"] = 8] = "ReplicaSets";
        KubeResourceType[KubeResourceType["DaemonSets"] = 16] = "DaemonSets";
        KubeResourceType[KubeResourceType["StatefulSets"] = 32] = "StatefulSets";
    })(KubeResourceType = exports.KubeResourceType || (exports.KubeResourceType = {}));
    var KubeServiceBase = /** @class */ (function () {
        function KubeServiceBase() {
        }
        KubeServiceBase.prototype.getPods = function (labelSelector) {
            return this.fetch(KubeResourceType.Pods, labelSelector);
        };
        KubeServiceBase.prototype.getDeployments = function () {
            return this.fetch(KubeResourceType.Deployments);
        };
        KubeServiceBase.prototype.getServices = function () {
            return this.fetch(KubeResourceType.Services);
        };
        KubeServiceBase.prototype.getReplicaSets = function () {
            return this.fetch(KubeResourceType.ReplicaSets);
        };
        KubeServiceBase.prototype.getDaemonSets = function () {
            return this.fetch(KubeResourceType.DaemonSets);
        };
        KubeServiceBase.prototype.getStatefulSets = function () {
            return this.fetch(KubeResourceType.StatefulSets);
        };
        return KubeServiceBase;
    }());
    exports.KubeServiceBase = KubeServiceBase;
});
